"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOTH = exports.OUTBOUND = exports.INBOUND = void 0;
var INBOUND = 'INBOUND';
exports.INBOUND = INBOUND;
var OUTBOUND = 'OUTBOUND';
exports.OUTBOUND = OUTBOUND;
var BOTH = 'BOTH';
exports.BOTH = BOTH;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/dataSyncs/Sync.js
// module id = 143
// module chunks = 209 210 211 212 213